module.exports = __webpack_public_path__ + "img/图层 5.9ff9fb6e.png";